<div class="flex-box">
    <filter-panel *ngIf="activeMenuCodes.includes(MapMenuCode.FILTERS)" class="flex-box"></filter-panel>
</div>
<div class="app-menus">
    <layer-list *ngIf="activeMenuCodes.includes(MapMenuCode.LAYERS)" class="map-menus layer-list"></layer-list>

    <legacy-task-panel
        class="legacy-task-list map-menus"
        *ngIf="activeMenuCodes.includes(MapMenuCode.LEGACY_TASKS)"
    ></legacy-task-panel>
    <task-panel class="task-list map-menus" *ngIf="activeMenuCodes.includes(MapMenuCode.TASKS)"></task-panel>
    <task-panel
        class="task-list map-menus add-to-task"
        *ngIf="activeMenuCodes.includes(MapMenuCode.ADD_TO_TASK)"
        [isAddToTaskMode]="true"
    ></task-panel>

    <survey-job-panel
        class="survey-job-list map-menus"
        *ngIf="activeMenuCodes.includes(MapMenuCode.SURVEY_JOBS)"
    ></survey-job-panel>
</div>
